module.exports = __webpack_public_path__ + "img/hr-fast-inserter-hand-base.75bf1205.png";